import { init_editor_values_multiple_choice_survey } from 'src/components/templates/MultipleChoiceSurvey/initValues';
import { init_editor_values_rating_answer_survey } from 'src/components/templates/RatingAnswerSurvey/initValues';
import { init_editor_values_short_answer_survey } from 'src/components/templates/ShortAnswerSurvey/initValues';

export const UPCOMING_TEMPLATES: any = [
  'SELECT OPTION SURVEY',
  'PREFERENCE QUESTION',
  'NPS MODAL SURVEY'
];
export const PLUS_TEMPLATES: any = [
  'MULTIPLE CHOICE SURVEY',
  'SHORT ANSWER SURVEY',
  'RATING ANSWER SURVEY',
  'SELECT OPTION SURVEY',
  'NPS MODAL SURVEY'
];
export const NEW_TEMPLATES: any = [
  'SIMPLE ICON MODAL',
  'CAROUSEL SLIDE MODAL',
  'AUTO SQUARE SLIDE'
  // 'MULTIPLE CHOICE SURVEY',
  // 'SHORT ANSWER SURVEY',
  // 'RATING ANSWER SURVEY'
];
export const TEMPLATES: any = [
  'BASIC FULL COUNTDOWN',
  'BOTTOM SHEET IMAGE',
  'RADIUS MODAL SLIDE',
  'FULL DUAL IMAGE',
  'MODAL SLIDE',
  'SLIDE MODAL ROUND',
  'SIMPLE MODAL SLIDE',
  'BOTTOM SHEET SLIDE',
  'BASIC FULL IMAGE',
  'RADIUS FULL COUNTDOWN',
  'SIMPLE MODAL',
  'SLIDE FULL IMAGE',
  'SLIDE MODAL IMAGE',
  'AUTO MODAL SLIDE',
  'COUPON BOTTOM SHEET',
  'IMAGE BOTTOM SHEET',
  'ALARM MODAL'
];

export const CHANGE_IMAGE: any = {
  'full-countdown': 'basic-full-countdown',
  'basic-full-countdown': 'basic-full-countdown',
  'bottom-sheet-image': 'bottom-sheet-image',
  'modal-pading-slide': 'radius-modal-slide',
  'radius-modal-slide': 'radius-modal-slide',
  'full-dual-image': 'full-dual-image',
  'modal-slick-contents': 'modal-slide',
  'modal-slide': 'modal-slide',
  'full-survey': 'simple-survey',
  'simple-survey': 'simple-survey',
  'modal-slide-image': 'slide-modal-round',
  'slide-modal-round': 'slide-modal-round',
  'modal-top-image': 'simple-modal-slide',
  'simple-modal-slide': 'simple-modal-slide',
  'half-slide-up-imgs': 'bottom-sheet-slide',
  'bottom-sheet-slide': 'bottom-sheet-slide',
  'nps-modal-dial': 'nps-modal-survey',
  'promotion-full-image': 'basic-full-image',
  'basic-full-image': 'basic-full-image',
  'countdown-full-circle': 'radius-full-countdown',
  'radius-full-countdown': 'radius-full-countdown',
  'modal-slider-survey': 'modal-slider-survey',
  'slide-full-image': 'slide-full-image',
  'slide-modal-image': 'slide-modal-image',
  'auto-modal-slide': 'auto-modal-slide',
  'cupon-bottom-sheet': 'coupon-bottom-sheet',
  'coupon-bottom-sheet': 'coupon-bottom-sheet',
  'image-bottom-sheet': 'image-bottom-sheet',
  'list-modal': 'list-modal',
  'alarm-modal': 'alarm-modal',
  'half-slide-up': 'bottom-sheet-slide',
  'single-modal-top': 'simple-modal-slide',
  'half-top-image': 'bottom-sheet-image',
  'modal-paging-slide': 'radius-modal-slide',
  'modal-full-image': 'simple-modal',
  'multiple-choice-survey': 'multiple-choice-survey',
  'simple-modal': 'simple-modal',
  'short-answer-survey': 'short-answer-survey',
  'rating-answer-survey': 'rating-answer-survey',
  // 추가중
  'auto-square-slide': 'auto-square-slide',
  'carousel-slide-modal': 'carousel-slide-modal',
  'simple-icon-modal': 'simple-icon-modal'
};

export const CHANGE_TEMPLATE: any = {
  'FULL COUNTDOWN': 'BASIC FULL COUNTDOWN',
  'BASIC FULL COUNTDOWN': 'BASIC FULL COUNTDOWN',
  'BOTTOM SHEET IMAGE': 'BOTTOM SHEET IMAGE',
  'MODAL PADING SLIDE': 'RADIUS MODAL SLIDE',
  'RADIUS MODAL SLIDE': 'RADIUS MODAL SLIDE',
  'FULL DUAL IMAGE': 'FULL DUAL IMAGE',
  'MODAL SLICK CONTENTS': 'MODAL SLIDE',
  'MODAL SLIDE': 'MODAL SLIDE',
  'FULL SURVEY': 'SIMPLE SURVEY',
  'SIMPLE SURVEY': 'SIMPLE SURVEY',
  'MODAL SLIDE IMAGE': 'SLIDE MODAL ROUND',
  'SLIDE MODAL ROUND': 'SLIDE MODAL ROUND',
  'MODAL TOP IMAGE': 'SIMPLE MODAL SLIDE',
  'SIMPLE MODAL SLIDE': 'SIMPLE MODAL SLIDE',
  'HALF SLIDE UP IMGS': 'BOTTOM SHEET SLIDE',
  'BOTTOM SHEET SLIDE': 'BOTTOM SHEET SLIDE',
  'NPS MODAL DIAL': 'NPS MODAL SURVEY',
  'NPS MODAL SURVEY': 'NPS MODAL SURVEY',
  'PROMOTION FULL IMAGE': 'BASIC FULL IMAGE',
  'BASIC FULL IMAGE': 'BASIC FULL IMAGE',
  'COUNTDOWN FULL CIRCLE': 'RADIUS FULL COUNTDOWN',
  'RADIUS FULL COUNTDOWN': 'RADIUS FULL COUNTDOWN',
  'MODAL SLIDER SURVEY': 'MODAL SLIDER SURVEY',
  'SLIDE FULL IMAGE': 'SLIDE FULL IMAGE',
  'SLIDE MODAL IMAGE': 'SLIDE MODAL IMAGE',
  'AUTO MODAL SLIDE': 'AUTO MODAL SLIDE',
  'COPON BOTTOM SHEET': 'COUPON BOTTOM SHEET',
  'COUPON BOTTOM SHEET': 'COUPON BOTTOM SHEET',
  'IMAGE BOTTOM SHEET': 'IMAGE BOTTOM SHEET',
  // 'LIST MODAL': 'LIST MODAL',
  'ALARM MODAL': 'ALARM MODAL',
  'HALF SLIDE UP': 'BOTTOM SHEET SLIDE',
  'SINGLE MODAL TOP': 'SIMPLE MODAL SLIDE',
  'HALF TOP IMAGE': 'BOTTOM SHEET IMAGE',
  'MODAL PAGING SLIDE': 'RADIUS MODAL SLIDE',
  'SIMPLE MODAL': 'SIMPLE MODAL',
  'MODAL FULL IMAGE': 'SIMPLE MODAL',
  'MULTIPLE CHOICE SURVEY': 'MULTIPLE CHOICE SURVEY',
  'SHORT ANSWER SURVEY': 'SHORT ANSWER SURVEY',
  'RATING ANSWER SURVEY': 'RATING ANSWER SURVEY',
  // 추가중
  'AUTO SQUARE SLIDE': 'AUTO SQUARE SLIDE',
  'CAROUSEL SLIDE MODAL': 'CAROUSEL SLIDE MODAL',
  'SIMPLE ICON MODAL': 'SIMPLE ICON MODAL'
};

export const TEMPLATES_EDITOR = {
  'MULTIPLE CHOICE SURVEY': init_editor_values_multiple_choice_survey,
  'SHORT ANSWER SURVEY': init_editor_values_short_answer_survey,
  'RATING ANSWER SURVEY': init_editor_values_rating_answer_survey
};

export const TEMPLATES_TRACKING_EDITOR = {
  'BASIC FULL COUNTDOWN': ['background', 'button'],
  'BOTTOM SHEET IMAGE': ['multi_image', 'multi_button', 'multi_sub_button'],
  'RADIUS MODAL SLIDE': ['multi_image', 'multi_button', 'multi_sub_button'],
  'FULL DUAL IMAGE': ['multi_image', 'multi_button', 'button'],
  'MODAL SLIDE': ['multi_image', 'multi_button', 'multi_sub_button'],

  'SLIDE MODAL ROUND': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'SIMPLE MODAL SLIDE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'BOTTOM SHEET SLIDE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'BASIC FULL IMAGE': ['background', 'left_button', 'right_button'],
  'RADIUS FULL COUNTDOWN': ['background', 'button', 'sub_button'],
  'SIMPLE MODAL': ['background', 'button', 'sub_button', 'never_show_button'],
  'MULTIPLE CHOICE SURVEY': [
    'multi_action_survey',
    'multi_button',
    'multi_sub_button'
  ],
  'SLIDE FULL IMAGE': ['multi_image', 'multi_button', 'multi_sub_button'],
  'SLIDE MODAL IMAGE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'AUTO MODAL SLIDE': [
    'multi_image',
    'multi_button',
    'left_button',
    'right_button'
  ],
  'SHORT ANSWER SURVEY': [
    'multi_action_survey',
    'multi_textarea',
    'multi_left_button',
    'multi_right_button'
  ],
  'COUPON BOTTOM SHEET': ['button', 'sub_button', 'coupon_button'],
  'IMAGE BOTTOM SHEET': ['button', 'sub_button'],
  // 'LIST MODAL': ['button', 'left_button', 'right_button'],
  'ALARM MODAL': ['button', 'left_button', 'right_button', 'never_show_button'],
  // 추가중 네이버 커스터마이징
  'AUTO SQUARE SLIDE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  // this will be carousel slide modal
  'CAROUSEL SLIDE MODAL': [
    'multi_image',
    'multi_button',
    'multi_left_button',
    'multi_right_button'
  ],
  'SIMPLE ICON MODAL': ['button', 'right_button', 'left_button']
};

export const TEMPLATES_EDITOR_REGARCY = {
  'BASIC FULL COUNTDOWN': {
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      textType: ['year_title', 'title', 'sub_title', 'countdown_title'],
      countdownType: ['countdown']
    },
    button: {
      btnType: ['button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['background', 'button']
    }
  },
  'BOTTOM SHEET IMAGE': {
    multi: [1, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [180],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button', 'multi_sub_button'],
      radiusType: ['multi_button', 'multi_sub_button'],
      radiusMax: [32, 32]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  'RADIUS MODAL SLIDE': {
    multi: [3, 7],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [100],
      textType: ['countdown_title'],
      multiTextType: ['multi_title'],
      multiCountdownType: ['multi_countdown']
    },
    button: {
      multiBtnType: ['multi_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  'FULL DUAL IMAGE': {
    multi: [1, 2],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [100],
      textType: ['title', 'sub_title'],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      btnType: ['button'],
      multiBtnType: ['multi_button'],
      radiusType: ['button', 'multi_button'],
      radiusMax: [32, 12]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'button']
    }
  },
  // 'CAROUSEL SLIDE MODAL' 추가중
  'CAROUSEL SLIDE MODAL': {
    multi: [3, 10],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 100],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button', 'multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button'],
      radiusType: ['multi_button'],
      radiusMax: [24]
    },
    tracking: {
      trackingType: [
        'multi_image',
        'multi_button',
        'multi_left_button',
        'multi_right_button'
      ]
    }
  },

  'MODAL SLIDE': {
    multi: [3, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 100],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button'],
      radiusType: ['multi_button'],
      radiusMax: [24]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  // 'SIMPLE SURVEY': {
  //   text: {
  //     type: ['title', 'sub_title']
  //   },
  //   button: {
  //     btnType: ['none_survey', 'button'],
  //     multiBtnType: ['multi_survey']
  //   }
  // },
  'AUTO SQUARE SLIDE': {
    multi: [1, 10],
    text: {
      // bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 150]
      // multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },

  'SLIDE MODAL ROUND': {
    multi: [1, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 150],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'SIMPLE MODAL SLIDE': {
    multi: [1, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [50],
      multiTextType: ['multi_title', 'multi_sub_title', 'multi_box_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      radiusType: ['multi_left_button', 'multi_right_button'],
      radiusMax: [24, 24]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'BOTTOM SHEET SLIDE': {
    multi: [1, 7],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [180],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'BASIC FULL IMAGE': {
    text: {
      imageType: ['background'],
      deeplinkType: ['background']
    },
    button: {
      btnType: ['left_button', 'right_button'],
      againType: ['left_button']
    },
    tracking: {
      trackingType: ['background', 'left_button', 'right_button']
    }
  },
  'RADIUS FULL COUNTDOWN': {
    text: {
      imageType: ['background'],
      deeplinkType: ['background'],
      textType: ['sub_title', 'title'],
      countdownType: ['countdown']
    },
    button: {
      btnType: ['button', 'sub_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'sub_button']
    }
  },
  'SIMPLE MODAL': {
    text: {
      imageType: ['background'],
      deeplinkType: ['background']
    },
    button: {
      btnType: ['button', 'never_show_button'],
      againType: ['never_show_button'],
      radiusType: ['button', 'never_show_button'],
      radiusMax: [24, 24]
    },
    tracking: {
      trackingType: ['background', 'button', 'sub_button', 'never_show_button']
    }
  },
  'MULTIPLE CHOICE SURVEY': {
    multi: [1, 12],
    text: {
      multiBgType: ['multi_background'],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_action_survey', 'none_survey', 'multi_button'],
      multiAgainType: ['type', 'multi_action_survey']
    },
    tracking: {
      trackingType: ['multi_action_survey', 'multi_button', 'multi_sub_button']
    }
  },
  'SLIDE FULL IMAGE': {
    multi: [3, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [120],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button'],
      type: ['sub_button'],
      radiusType: ['multi_button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  'SLIDE MODAL IMAGE': {
    multi: [3, 7],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [150],
      multiTextType: ['multi_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'AUTO MODAL SLIDE': {
    multi: [3, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 100],
      textType: ['title', 'sub_title']
    },
    button: {
      multiBtnType: ['multi_button'],
      btnType: ['left_button', 'right_button'],
      againType: ['left_button']
    },
    tracking: {
      trackingType: [
        'multi_image',
        'multi_button',
        'left_button',
        'right_button'
      ]
    }
  },
  'COUPON BOTTOM SHEET': {
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [180],
      textType: ['title', 'coupon_title', 'coupon_sub_title', 'coupon_date']
    },
    button: {
      btnType: ['coupon_button', 'button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'sub_button', 'coupon_button']
    }
  },
  'IMAGE BOTTOM SHEET': {
    text: {
      imageType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [180],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'sub_button']
    }
  },
  'ALARM MODAL': {
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [50],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button', 'sub_button'],
      againType: ['never_show_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'left_button', 'right_button']
    }
  },
  'SIMPLE ICON MODAL': {
    text: {
      bgType: ['background'],
      imageType: ['logo'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [50],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button', 'sub_button'],
      againType: ['never_show_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'left_button', 'right_button']
    }
  }
};
